// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.volume_wrapper__LIF6S {
  --thumb-size: 12px;
  --track-height: 4px;
  --volume-slider-size: 60px;
  --margin-slider-button: 4px;

  flex: none;
  display: flex;
  align-items: center;

  position: relative;
}

.volume_sliderWrapper__cu5U2 {
  display: flex;
  align-items: center;
}

input[type='range'].volume_input__hUbEH {
  width: 1px; /* This cannot be 0 because Safari doesn't understand that */
  opacity: 0;

  transition-property: margin-left, width, opacity;
  transition-duration: 0.3s;
  transition-delay: 0.4s;
}

.volume_wrapper__LIF6S:hover .volume_input__hUbEH,
.volume_wrapper__LIF6S:focus-within .volume_input__hUbEH {
  width: var(--volume-slider-size);
  margin-left: var(--margin-slider-button);
  opacity: 1;

  transition-delay: 0s;
  transition-duration: 0.3s, 0.5s;
}

/* vertical slider */

.volume_sliderWrapper__cu5U2.volume_vertical__8wyL0 {
  position: absolute;
  padding: var(--thumb-size);
  border-radius: var(--thumb-size);
  bottom: calc(var(--volume-slider-size) - 8px);
  left: 50%;
  z-index: -10; /* This avoids the slider to show up on hover (of the slider itself) */

  transform: translate(-50%) rotate(-90deg);
  transition-property: opacity;
  transition-duration: 0.3s;

  background: var(--overlayBackground);
  opacity: 0;
}

.volume_sliderWrapper__cu5U2.volume_vertical__8wyL0 input.volume_input__hUbEH[type='range'] {
    width: var(--volume-slider-size);
    margin-left: 0;
  }

.volume_wrapper__LIF6S:hover .volume_sliderWrapper__cu5U2.volume_vertical__8wyL0,
.volume_wrapper__LIF6S:focus-within .volume_sliderWrapper__cu5U2.volume_vertical__8wyL0 {
  opacity: 1;
  z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/volume/volume.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;;EAE3B,UAAU;EACV,aAAa;EACb,mBAAmB;;EAEnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU,EAAE,4DAA4D;EACxE,UAAU;;EAEV,gDAAgD;EAChD,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,gCAAgC;EAChC,wCAAwC;EACxC,UAAU;;EAEV,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA,oBAAoB;;AAEpB;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gCAAgC;EAChC,6CAA6C;EAC7C,SAAS;EACT,YAAY,EAAE,sEAAsE;;EAEpF,yCAAyC;EACzC,4BAA4B;EAC5B,yBAAyB;;EAEzB,oCAAoC;EACpC,UAAU;AAMZ;;AAJE;IACE,gCAAgC;IAChC,cAAc;EAChB;;AAGF;;EAEE,UAAU;EACV,UAAU;AACZ","sourcesContent":[".wrapper {\n  --thumb-size: 12px;\n  --track-height: 4px;\n  --volume-slider-size: 60px;\n  --margin-slider-button: 4px;\n\n  flex: none;\n  display: flex;\n  align-items: center;\n\n  position: relative;\n}\n\n.sliderWrapper {\n  display: flex;\n  align-items: center;\n}\n\ninput[type='range'].input {\n  width: 1px; /* This cannot be 0 because Safari doesn't understand that */\n  opacity: 0;\n\n  transition-property: margin-left, width, opacity;\n  transition-duration: 0.3s;\n  transition-delay: 0.4s;\n}\n\n.wrapper:hover .input,\n.wrapper:focus-within .input {\n  width: var(--volume-slider-size);\n  margin-left: var(--margin-slider-button);\n  opacity: 1;\n\n  transition-delay: 0s;\n  transition-duration: 0.3s, 0.5s;\n}\n\n/* vertical slider */\n\n.sliderWrapper.vertical {\n  position: absolute;\n  padding: var(--thumb-size);\n  border-radius: var(--thumb-size);\n  bottom: calc(var(--volume-slider-size) - 8px);\n  left: 50%;\n  z-index: -10; /* This avoids the slider to show up on hover (of the slider itself) */\n\n  transform: translate(-50%) rotate(-90deg);\n  transition-property: opacity;\n  transition-duration: 0.3s;\n\n  background: var(--overlayBackground);\n  opacity: 0;\n\n  & input[type='range'].input {\n    width: var(--volume-slider-size);\n    margin-left: 0;\n  }\n}\n\n.wrapper:hover .sliderWrapper.vertical,\n.wrapper:focus-within .sliderWrapper.vertical {\n  opacity: 1;\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `volume_wrapper__LIF6S`,
	"sliderWrapper": `volume_sliderWrapper__cu5U2`,
	"input": `volume_input__hUbEH`,
	"vertical": `volume_vertical__8wyL0`
};
export default ___CSS_LOADER_EXPORT___;
